(function () {
    var root = document.querySelector('.timer-new[datetime]');
    if (!root) return;

    // 1) Normalizuj ISO: 2025-9-17T23:59:00.000+0100 -> 2025-09-17T23:59:00.000+01:00
    function normalizeISO(s) {
    if (!s) return s;
    // YYYY-M-D -> YYYY-MM-DD
    s = s.replace(/^(\d{4})-(\d{1,2})-(\d{1,2})/, function(_, y, m, d){
    return y + '-' + String(m).padStart(2,'0') + '-' + String(d).padStart(2,'0');
});
    // +hhmm ili -hhmm -> +hh:mm
    s = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    return s;
}

    function parseISOWithOffset(isoRaw) {
    var iso = normalizeISO(isoRaw);
    var d = new Date(iso);
    if (!isNaN(d)) return d;

    var m = iso.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?([+-])(\d{2}):(\d{2})$/
    );
    if (!m) return null;
    var year = +m[1], mon = +m[2], day = +m[3];
    var hh = +m[4], mm = +m[5], ss = +(m[6] || 0);
    var sign = m[7] === '-' ? -1 : 1;
    var offH = +m[8], offM = +m[9];
    var offsetMin = sign * (offH * 60 + offM);
    var utcMs = Date.UTC(year, mon - 1, day, hh, mm, ss) - offsetMin * 60000;
    return new Date(utcMs);
}

    var target = parseISOWithOffset(root.getAttribute('datetime'));
    if (!target || isNaN(target)) {
    console.warn('Invalid datetime:', root.getAttribute('datetime'));
    return;
}

    var elDays = document.getElementById('new_days');
    var elHours = document.getElementById('new_hours');
    var elMins = document.getElementById('new_minutes');
    var elSecs = document.getElementById('new_seconds');
    var elExpired = root.querySelector('.timer_expair_text');

    function showValues() {
    // skini inline "display:none" sa vrednosti i labela
    root.querySelectorAll('span').forEach(function (s) {
    if (!s.classList.contains('timer_expair_text')) {
    s.style.display = 'inline';
}
});
    if (elExpired) elExpired.style.display = 'none';
}

    function showExpired() {
    // sakrij vrednosti, pokaži expired tekst
    root.querySelectorAll('span').forEach(function (s) {
    if (!s.classList.contains('timer_expair_text')) {
    s.style.display = 'none';
}
});
    if (elExpired) {
    if (!elExpired.textContent.trim()) {
    elExpired.textContent = 'Offer ended';
}
    elExpired.style.display = 'inline';
}
}

    function pad2(v){ return String(v).padStart(2,'0'); }

    function tick() {
    var now = new Date();
    var diff = target - now;

    if (diff <= 0) {
    showExpired();
    if (elDays)  elDays.textContent  = '00';
    if (elHours) elHours.textContent = '00';
    if (elMins)  elMins.textContent  = '00';
    if (elSecs)  elSecs.textContent  = '00';
    clearInterval(timerId);
    return;
}

    showValues();

    var d  = Math.floor(diff / 86400000);
    var h  = Math.floor((diff % 86400000) / 3600000);
    var m  = Math.floor((diff % 3600000) / 60000);
    var s  = Math.floor((diff % 60000) / 1000);

    if (elDays)  elDays.textContent  = pad2(d);
    if (elHours) elHours.textContent = pad2(h);
    if (elMins)  elMins.textContent  = pad2(m);
    if (elSecs)  elSecs.textContent  = pad2(s);
}

    tick();
    var timerId = setInterval(tick, 1000);
})();